import { ReactNode } from 'react';

import { LayoutCard, Stack } from '@cast/design-system';

type Props = {
  testId: string;
  main: ReactNode;
  sidePanel: ReactNode;
};

export const ClusterBannerLayout = ({ testId, main, sidePanel }: Props) => (
  <LayoutCard testId={testId} padding={false}>
    <Stack
      direction="row"
      alignItems="stretch"
      sx={{ width: '100%', minWidth: 0 }}
    >
      <Stack flex={1} minWidth={0}>
        {main}
      </Stack>
      {sidePanel}
    </Stack>
  </LayoutCard>
);
